export default {"src":"/_next/static/media/honda.8ba66594.svg","height":800,"width":1200,"blurWidth":0,"blurHeight":0};